<template>
    <div class="pageError">
        <div class="error_img">
            <img src="./../../assets/images/common/xiaohe2.png" alt="">
        </div>
        <p>页面地址有误，<a href="/home?source=edit">返回首页</a></p>
    </div>
</template>

<style lang="less" scoped>
.pageError{
    min-height: 100%;
    background: @expertFontColor255;
    text-align: center;
    overflow: hidden;
    .error_img{
        width: 100%;
        height: 128px;
        margin: 110px 0 20px;
        float: left;
        img{
            width: 128px;
            height: 128px;
        }
    }
    p{
        width: 100%;
        float: left;
        font-size:@indexFontSize14;
        color: @expertFontColor51;
        a{
            color: @mainColor2;
            border-bottom:1px solid @mainColor2;
        }
    }
}
</style>


<script>
export default {
    name: "pageError",
    components: {},
    data() {
        return {};
    },
    computed: {},
    mounted() {

    },
    created() {},
    methods: {}
};
</script>
